import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getOwnerNFTsService,
  getTrendingNFTsService,
  getWalletBalanceService,
  syncOwnerNFTsService,
} from "../../apiService/dashboard";

interface WalletBalancePayload {
  walletAddress: string | undefined;
  chain: string | undefined;
}

interface OwnerNFTsPayload {
  walletAddress: string | undefined;
  token: string;
}

interface FilteredNFTsPayload {
  limit: number;
  page: number;
  name?: string;
  blockchain_network?: string;
  rank_by?: string;
  category_id?: string;
  eco_category_id?: string;
}

export const getOwnerNFTs = createAsyncThunk(
  "vyga/getOwnerNFTs",
  async ({ walletAddress, token }: OwnerNFTsPayload, { rejectWithValue }) => {
    try {
      const result = await getOwnerNFTsService(walletAddress, token);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getWalletBalance = createAsyncThunk(
  "vyga/getWalletBalance",
  async (
    { walletAddress, chain }: WalletBalancePayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await getWalletBalanceService(walletAddress, chain);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const syncOwnerNFTs = createAsyncThunk(
  "vyga/syncOwnerNFTs",
  async (walletAddress: string, { rejectWithValue }) => {
    try {
      const result = await syncOwnerNFTsService(walletAddress);
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getTrendingNFTs = createAsyncThunk(
  "vyga/getTrendingNFTs",
  async (
    {
      limit,
      page,
      name = "",
      blockchain_network = "",
      rank_by = "",
      category_id = "",
      eco_category_id = "",
    }: FilteredNFTsPayload,
    { rejectWithValue }
  ) => {
    try {
      const result = await getTrendingNFTsService(
        limit,
        page,
        name,
        blockchain_network,
        rank_by,
        category_id,
        eco_category_id
      );
      return result;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
